import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LeaveTypesService {
  public REST_API_SERVER:string = `${environment.REST_API_URL}/api/web/${environment.version}`;
  
  constructor(private http:HttpClient) { }

  public getLeaveTypes(filterParams:any={}):Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/leavetypes`,{params:filterParams,observe:'response'});
  }

  public createLeaveType(data:any):Observable<any>{
    return this.http.post(`${this.REST_API_SERVER}/leavetypes/create`,data);
  }
}